import { render, staticRenderFns } from "./parkurcomp.vue?vue&type=template&id=7883f4fa&"
import script from "./parkurcomp.vue?vue&type=script&lang=js&"
export * from "./parkurcomp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports